
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import ListingPropertyCharacteristics from '../property-characteristics';

export default {
  name: 'ListingAccordionContent',
  components: {
    Typography,
    ListingPropertyCharacteristics,
  },
  props: {
    description: {
      default: '',
      type: String,
    },
    characteristicSections: {
      default: () => [],
      type: Array,
    },
    colorScheme: {
      default: StyleColorSchemeType.White,
      type: String,
    },
  },
  data() {
    return {
      TypographyType,
    };
  },
};
